import { t } from "@lingui/macro"

export const getFormTitleValues = (): Record<string, string> => ({
    mr: t`Form Title Mr.`,
    mrs: t`Form Title Mrs.`,
    miss: t`Form Title Miss.`,
    ms: t`Form Title Ms.`,
    dr: t`Form Title Dr.`,
    dir: t`Form Title Dir.`,
    lady: t`Form Title Lady.`,
    prof: t`Form Title Prof.`,
    lord: t`Form Title Lord.`,
})
